import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";
import { getAuditLog } from "../api/rbac-api";
import type { AuditLogFilters, AuditLogResponse } from "../types/RolesPermissions.type";

export const AUDIT_LOG_KEYS = {
	all: ["rbac", "audit"] as const,
	list: (filters: AuditLogFilters) => [...AUDIT_LOG_KEYS.all, "list", filters] as const,
};

export const useAuditLog = (filters: AuditLogFilters): UseQueryResult<AuditLogResponse> => {
	return useQuery({
		queryKey: AUDIT_LOG_KEYS.list(filters),
		queryFn: () => getAuditLog(filters),
	});
};
